import React from 'react'
import ProjectListContainer from '../../../../Components/Applications/Project/ProjectList'

export default function ProjectList() {
  return (
    <div className='page-body'>
      <ProjectListContainer />
    </div>
  )
}